import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl, imageUrl } from "../../Baseurl";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import SellerNavbar from "../../component/SellerNavbar";
import SellerSidebar from "../../component/SellerSidebar";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const getBadgeClass = (status) => {
  if (!status || status.trim() === "") return "bg-primary";
  switch (status.toLowerCase()) {
    case "processing":
      return "bg-warning text-dark";
    case "out for delivery":
      return "bg-info text-dark";
    case "delivered":
      return "bg-success";
    default:
      return "bg-secondary";
  }
};

// NEW — CANCEL BADGE COLORS
const getCancelBadgeClass = (status) => {
  if (!status) return "bg-secondary";
  switch (status.toLowerCase()) {
    case "cancelled":
      return "bg-danger";
    case "pending":
      return "bg-warning text-dark";
    case "requested":
      return "bg-info text-dark";
    default:
      return "bg-secondary";
  }
};

// NEW — REFUND BADGE COLORS
const getRefundBadgeClass = (status) => {
  if (!status) return "bg-secondary";
  switch (status.toLowerCase()) {
    case "initiated":
      return "bg-warning text-dark";
    case "completed":
      return "bg-success";
    case "failed":
      return "bg-danger";
    default:
      return "bg-secondary";
  }
};

const AllMyOrders = () => {
  const [loading, setLoading] = useState(true);
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const sellerId = localStorage.getItem("seller_id");

  useEffect(() => {
    if (!sellerId) {
      Swal.fire("Error", "Seller ID is missing!", "error");
      return;
    }

    const fetchOrders = async () => {
      try {
        const response = await axios.get(`${baseurl}getOrdersBySellerId/${sellerId}`);
        const fetchedOrders = response.data.orders || [];
        setOrders(fetchedOrders);
        setFilteredOrders(fetchedOrders);
      } catch (error) {
        console.error("Error fetching orders:", error);
        Swal.fire("Error", "Failed to load orders", "error");
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [sellerId]);

  useEffect(() => {
    const lowerSearch = searchTerm.toLowerCase();
    const filtered = orders.filter((order) => {
      return (
        order.order_unique_id.toLowerCase().includes(lowerSearch) ||
        order.payment_method.toLowerCase().includes(lowerSearch) ||
        order.matched_cart_items.some((item) =>
          item.title.toLowerCase().includes(lowerSearch)
        )
      );
    });
    setFilteredOrders(filtered);
    setCurrentPage(1);
  }, [searchTerm, orders]);

  const indexOfLast = currentPage * perPage;
  const indexOfFirst = indexOfLast - perPage;
  const currentOrders = filteredOrders.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredOrders.length / perPage);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);



  const handleRefundChange = async (orderId, newStatus) => {
  if (!newStatus) return;

  let failedReason = "";

  if (newStatus === "failed") {
    failedReason = prompt("Enter refund failed reason:");
    if (!failedReason) {
      Swal.fire("Error", "Failed reason is required!", "error");
      return;
    }
  }

  try {
    const payload = {
      refund_status: newStatus,
      refund_failed_reason: failedReason
    };

    console.log("payload",payload);
    console.log("orderId",orderId);

    const res = await axios.put(`${baseurl}updateRefundStatusByOrderId/${orderId}`, payload);

    Swal.fire("Success", "Refund status updated!", "success");

    // Refresh list
    const response = await axios.get(`${baseurl}getOrdersBySellerId/${sellerId}`);
    setOrders(response.data.orders);
    setFilteredOrders(response.data.orders);

  } catch (err) {
    console.error(err);
    Swal.fire("Error", "Unable to update refund status", "error");
  }
};



  return (
    <>
      <SellerNavbar />
      <div>
        <section className="mb-5">
          <div className="container-fluid">
            <div className="row my-3 g-2 justify-content-center">
              <div className="col-md-2 hide-on-mobile">
                <SellerSidebar />
              </div>

              <div className="col-md-10">
                <div className="reviewcls text-start p-3 rounded shadow-sm bg-white">
                  <h4 className="selh1 mb-1 fw-bold text-primary">My Orders</h4>
                  <p className="text-muted">View details of your received orders below.</p>

                  {/* Search and Filter Controls */}
                  <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                    <input
                      type="text"
                      placeholder="🔍 Search by Order ID, Payment Method, or Product Name"
                      className="form-control search-input"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <div className="d-flex align-items-center gap-2">
                      <label className="fw-bold mb-0">Records:</label>
                      <select
                        className="form-select w-auto"
                        value={perPage}
                        onChange={(e) => setPerPage(parseInt(e.target.value))}
                      >
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                      </select>
                    </div>
                  </div>

                  {/* Table Section */}
                  {loading ? (
                    <table className="custom-table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Order ID</th>
                          <th>Total (₹)</th>
                          <th>Payment</th>
                          <th>Date</th>
                          <th>Products</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array(5)
                          .fill()
                          .map((_, index) => (
                            <tr key={index}>
                              <td><Skeleton width={20} /></td>
                              <td><Skeleton width={120} /></td>
                              <td><Skeleton width={80} /></td>
                              <td><Skeleton width={90} /></td>
                              <td><Skeleton width={120} /></td>
                              <td><Skeleton count={2} width={200} /></td>
                              <td><Skeleton width={90} height={30} /></td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  ) : filteredOrders.length === 0 ? (
                    <p className="text-center text-muted my-4">No orders found.</p>
                  ) : (
                    <div className="table-responsive">
                      <table className="custom-table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Order ID</th>
                            <th>Total (₹)</th>
                            <th>Payment</th>
                            <th>Date</th>
                            <th>Products</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentOrders.map((order, index) => (
                            <tr key={order.order_id}>
                              <td>{indexOfFirst + index + 1}</td>

                              <td>
                                <strong>{order.order_unique_id}</strong>

                                {/* Product Badge */}
                               {/* Product Badge — hide if order is cancelled */}
{order.cancel_status !== "cancelled" && (
  <div className="mt-1">
    {order.matched_cart_items.map((item) => (
      <span
        key={item.cart_id}
        className={`badge rounded-pill mt-1 ${getBadgeClass(
          item.status_by_seller
        )}`}
      >
        {item.status_by_seller?.trim() || "Active"}
      </span>
    ))}
  </div>
)}

                                {/* CANCEL STATUS */}
                                {order.cancel_status === "cancelled" && (
                                  <div className="mt-2">
                                    <span className={`badge rounded-pill ${getCancelBadgeClass(order.cancel_status)}`}>
                                      ❌ Cancelled
                                    </span>
                                    <br />
                                    <small className="text-danger">
                                      Reason: {order.cancel_reason}
                                    </small>
                                    {/* <br />
                                    <small className="text-muted">
                                      At: {new Date(order.cancelled_at).toLocaleString()}
                                    </small> */}
                                  </div>
                                )}

                                {/* REFUND STATUS */}
                               {/* REFUND STATUS + UPDATE OPTION */}
{order.cancel_status === "cancelled" && order.payment_method === "Online" && (
  <div className="mt-2">

    {/* Refund Status Badge */}
    {order.refund_status !== "not_applicable" && (
      <>
        <span className={`badge rounded-pill ${getRefundBadgeClass(order.refund_status)}`}>
          💰 Refund: {order.refund_status}
        </span>

        {order.refund_status === "initiated" && (
          <small className="text-warning d-block">
            Initiated at: {new Date(order.refund_initiated_at).toLocaleString()}
          </small>
        )}

        {order.refund_status === "failed" && (
          <small className="text-danger d-block">
            Failed: {order.refund_failed_reason}
          </small>
        )}
      </>
    )}

    {/* --- UPDATE REFUND STATUS --- */}
    <div className="mt-2">
      <select
        className="form-select form-select-sm"
        value={order.refund_status || ""}
        onChange={(e) => handleRefundChange(order.order_id, e.target.value)}
      >
        <option value="">Update Refund Status</option>
        <option value="initiated">Refund Initiated</option>
        <option value="completed">Refund Completed</option>
        <option value="failed">Refund Failed</option>
      </select>
    </div>
  </div>
)}

                              </td>

                              <td>₹{parseFloat(order.total).toLocaleString("en-IN")}</td>
                              <td>{order.payment_method}</td>
                              <td>{new Date(order.created_at).toLocaleString()}</td>

                              <td>
                                {order.matched_cart_items.map((item) => (
                                  <div
                                    key={item.cart_id}
                                    className="d-flex align-items-start mb-2"
                                  >
                                    <img
                                      src={`${imageUrl}listing/${item.image}`}
                                      alt={item.title}
                                      className="product-thumb"
                                    />
                                    <div>
                                      <strong>{item.title}</strong> × {item.quantity}
                                      <br />
                                      <small className="text-muted">
                                        ₹{item.price} + ₹{item.delivery_charge} ({item.delivery_method})
                                      </small>
                                    </div>
                                  </div>
                                ))}
                              </td>

                             <td>
  {order.cancel_status !== "cancelled" && (
    <Link
      to={`/order-details/${order.order_unique_id}/${sellerId}`}
      className="btn btn-sm btn-outline-primary"
    >
      View Details
    </Link>
  )}
</td>

                            </tr>
                          ))}
                        </tbody>
                      </table>

                      {/* Pagination */}
                      {totalPages > 1 && (
                        <nav>
                          <ul className="pagination justify-content-end mt-3">
                            {Array.from({ length: totalPages }, (_, i) => (
                              <li
                                key={i}
                                className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                                onClick={() => paginate(i + 1)}
                              >
                                <button className="page-link">{i + 1}</button>
                              </li>
                            ))}
                          </ul>
                        </nav>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AllMyOrders;
